import { Fields } from '@components/forms'
import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { SignUpQuestionId } from './questionService/questionModules/signUpQuestionModules'
import { Question, QuestionType } from './utils/types'

export const QuestionField = ({
  question,
  questionId,
}: {
  question: Question
  questionId: SignUpQuestionId
}) => {
  const questionType = question.type

  const { setFieldValue } = useFormikContext()
  useEffect(() => {
    // if readonly, set the value to "seen"
    if (questionType === QuestionType.READONLY) {
      // todo: consider what value makes sense here and if should be `unseen` initially
      setFieldValue(questionId, 'seen')
    }
  }, [questionId, questionType, setFieldValue])

  switch (questionType) {
    case QuestionType.SINGLESELECT:
      return (
        <Fields.RadioGroup
          name={questionId}
          options={question.options}
          columns={1}
          version="v2"
          label={question.label}
        />
      )
    case QuestionType.TEXT:
      return <Fields.Text name={questionId} label={question.label} />
    case QuestionType.EMAIL:
      return <Fields.Email name={questionId} label={question.label} />
    case QuestionType.READONLY:
      return null
    case QuestionType.CONSENTBOX:
      return (
        <Fields.Checkbox name={questionId}>{question.label}</Fields.Checkbox>
      )
    default:
      // eslint-disable-next-line
      throw new Error(
        `Question type ${questionType} is not accounted for in QuestionField`
      )
  }
}
